import React, { FC } from 'react';
import { RootState, useSelector } from 'src/store';
import EditTracking from '../editor/EditTracking';

export const initTrackingValues = {
  tracking: {
    top_image_button: ['top-image'],
    bottom_image_button: ['bottom-image'],
    top_left_image_button: ['top-left-image'],
    top_right_image_button: ['top-right-image'],
    bottom_left_image_button: ['bottom-left-image'],
    bottom_right_image_button: ['bottom-right-image'],
    close_button: ['close']
  }
};

const ChoiceOptionImageTracking: FC = () => {
  const tracking = useSelector((state: RootState) => state.trackings.tracking);
  const switchImageType = useSelector(
    (state: RootState) => state.switchButton.switchImageType
  );

  const style = `
  .root_tracking {
    width: 100%;
    height: 100%;

    overflow: hidden;
    position: relative;
    background: none;
  }
  .content_tracking_wrapper {
    width: 100%;          
    height: 100%;
    
    display: flex;
    flex-direction: column;
    justify-content: flex-end;    
  }
  .center_tracking {
    width: 100%;
    gap: 150px;
    display: flex;
    flex-direction: column;    
    align-items: end;
    justify-content: end;
    
    padding-top: 150px;
    padding-bottom: 50px;
  }  
        
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <>
        <div className="root_tracking">
          <div className="content_tracking_wrapper">
            <div className="center_tracking">
              {switchImageType === 'double' ? (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '200px'
                  }}
                >
                  <EditTracking
                    value={tracking?.top_image_button}
                    type="top_image_button"
                  />
                  <EditTracking
                    value={tracking?.bottom_image_button}
                    type="bottom_image_button"
                  />
                </div>
              ) : (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '65px',
                    marginBottom: '30px'
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '15px'
                    }}
                  >
                    <EditTracking
                      value={tracking?.top_left_image_button}
                      type="top_left_image_button"
                    />
                    <EditTracking
                      value={tracking?.top_right_image_button}
                      type="top_right_image_button"
                    />
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '15px'
                    }}
                  >
                    <EditTracking
                      value={tracking?.bottom_left_image_button}
                      type="bottom_left_image_button"
                    />
                    <EditTracking
                      value={tracking?.bottom_right_image_button}
                      type="bottom_right_image_button"
                    />
                  </div>
                </div>
              )}
              <EditTracking
                value={tracking?.close_button}
                type="close_button"
              />
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default ChoiceOptionImageTracking;
